<h2>What is a CO2e value (carbon dioxide equivalent)?</h2>
<p>CO2e is a way to measure how much greenhouse gas is released during the production, transportation, and disposal of
    different types of foods. CO2e measurement identifies which foods have the most significant environmental impact and
    where we should concentrate our efforts to support sustainable food production and consumption.</p>
<p>Food production is a major source of greenhouse gas emissions, making up about 25% of the total emissions. The
    average carbon dioxide equivalent (CO2e) emissions of UK meals is currently at 1.7kg, exceeding the Paris Agreement
    target of &lt;0.5kg per meal by more than three times.</p>

<h2>Net Zero 2050</h2>
<p>The net-zero targets for CO2e emissions are becoming increasingly important as the world seeks to limit global
    warming to 1.5°C above pre-industrial levels by around 2050.</p>
<p>To achieve a net zero target for CO2e emissions, an average person needs to reduce their carbon footprint to around
    2-3 kg CO2e per day.</p>
<p>This can be accomplished by implementing actions such as decreasing energy consumption, opting for low-carbon
    transportation methods, adopting a predominantly plant-based diet, and actively reducing waste.</p>

<h2>Data source</h2>
<p>To calculate the CO2e values for specific food types, our system Pi uses data provided by the World Resources
    Institute and the Poore & Nemecek (2018) study published in the journal Science which is the largest meta-analysis
    of food systems to date.</p>
<p>Pi's carbon footprint labels are indicative and display meals with low, medium, and high carbon emissions to help you
    and your customers make more informed decisions. Let's work together to create a more sustainable future for our
    planet, one meal at a time!</p>